/** Continue adding an account only while the server confirms login has not started. */
export function createAccountProxyOperation() {
  const bytes = new Uint8Array(16)
  const cryptoApi = typeof window !== 'undefined' && window.crypto
  if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
    cryptoApi.getRandomValues(bytes)
  } else {
    for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256)
  }
  const suffix = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
  return { id: `ac_${suffix}`, step: 0 }
}

export function isWaitingForAccountProxy(response, operation) {
  const result = response && response.data
  const data = result && result.data
  return Boolean(operation && result && result.code === 30001 && data &&
    data.type === 'account_proxy_acquisition' && data.submission_state === 'waiting_proxy' &&
    data.login_started === false && data.account_saved === false && data.can_resend === true &&
    data.operation_id === operation.id && data.operation_step === operation.step &&
    Number.isInteger(operation.step) && operation.step >= 0 && operation.step < 2147483647)
}

export async function waitForAccountProxy(request, operation, {
  isCurrent, onWait, sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
}) {
  while (isCurrent()) {
    const response = await request(operation)
    if (!isCurrent()) return null
    if (!isWaitingForAccountProxy(response, operation)) return response
    onWait()
    const retryAfter = response.data.data.retry_after_seconds
    const seconds = Number.isFinite(retryAfter) ? Math.max(1, Math.min(3, retryAfter)) : 1
    await sleep(seconds * 1000)
    if (!isCurrent()) return null
    operation.step += 1
  }
  return null
}
